import { Navigate, Outlet, useLocation } from "react-router-dom";

import PageLoader from "@/common/components/PageLoader";
import { useAuth } from "@/common/hooks/useAuth";

export const AuthOnlyRoute = () => {
  const {
    isAuthenticated,
    isSuperAdmin,
    isBootstrappingFromHint,
    userPreferenceData,
    isUserPreferenceLoading,
  } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to={`/login?returnUrl=${encodeURIComponent(location.pathname + location.search + location.hash)}`}
        replace
      />
    );
  }

  // Wait for server session confirmation before making any redirect decisions.
  // See issue #2224 and ProtectedRoute for context.
  if (isBootstrappingFromHint) {
    return <PageLoader />;
  }

  if (isSuperAdmin) {
    return <Navigate to="/admin" replace />;
  }

  // Already completed onboarding — redirect to dashboard so they can't accidentally
  // re-run the wizard and create a duplicate org/workspace.
  if (
    !isUserPreferenceLoading &&
    userPreferenceData?.data?.versionId &&
    location.pathname === "/onboarding/wizard"
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};
